(() => {
  const config = window.XrootsLicenseConfig;
  if (!config?.enabled) return;

  const root = document.documentElement;

  const loadLockFont = () => {
    if (document.getElementById('xroots-license-montserrat')) return;

    const font = document.createElement('link');
    font.id = 'xroots-license-montserrat';
    font.rel = 'stylesheet';
    font.href = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap';
    document.head.append(font);
  };

  const createLockScreen = () => {
    loadLockFont();

    const screen = document.createElement('div');
    screen.className = 'xroots-license-lock-screen';
    screen.setAttribute('role', 'alert');

    const card = document.createElement('div');
    card.className = 'xroots-license-lock-card';

    if (config.lockLogoUrl) {
      const logo = document.createElement('img');
      logo.className = 'xroots-license-lock-logo';
      logo.src = config.lockLogoUrl;
      logo.alt = 'Loxaid';
      card.append(logo);
    }

    const title = document.createElement('strong');
    title.className = 'xroots-license-lock-title';
    title.textContent = 'Licença do tema inativa';

    const message = document.createElement('p');
    message.textContent = 'Este tema personalizado requer uma licença ativa para continuar sendo exibido.';

    const contact = document.createElement('a');
    contact.href = `https://wa.me/${config.whatsappNumber || '5585999671024'}`;
    contact.target = '_blank';
    contact.rel = 'noopener noreferrer';

    const contactLabel = document.createElement('span');
    contactLabel.textContent = 'Entre em contato';
    contact.append(contactLabel);

    if (config.lockWhatsappIconUrl) {
      const icon = document.createElement('img');
      icon.className = 'xroots-license-whatsapp-icon';
      icon.src = config.lockWhatsappIconUrl;
      icon.alt = '';
      icon.setAttribute('aria-hidden', 'true');
      contact.append(icon);
    }

    card.append(title, message, contact);
    screen.append(card);
    return screen;
  };

  const setState = (state, message, features = []) => {
    const enabledFeatures = state === 'verified' && Array.isArray(features) ? features : [];

    root.dataset.xrootsLicenseState = state;
    root.dataset.xrootsLicenseFeatures = enabledFeatures.join(' ');
    root.classList.remove('xroots-license--verified', 'xroots-license--restricted', 'xroots-license--locked', 'xroots-license--unverified');
    root.classList.add(`xroots-license--${state}`);
    root.classList.toggle('xroots-premium--enabled', state === 'verified');

    document.querySelector('.xroots-license-lock-screen')?.remove();
    if (state === 'locked' && !root.classList.contains('shopify-design-mode')) {
      document.body.append(createLockScreen());
    }

    if (!root.classList.contains('shopify-design-mode')) return;

    const notice = document.createElement('div');
    notice.className = `xroots-license-notice xroots-license-notice--${state}`;
    notice.setAttribute('role', 'status');
    notice.textContent = message;
    document.body.append(notice);
  };

  const endpointIsSecure = /^https:\/\//i.test(config.endpoint || '');
  if (!config.key || !endpointIsSecure || !config.shop) {
    setState('restricted', 'Licença não configurada. Recursos premium foram desativados.');
    return;
  }

  fetch(config.endpoint, {
    method: 'POST',
    cache: 'no-store',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ license_key: config.key, shop: config.shop, theme: config.theme })
  })
    .then((response) => {
      if (!response.ok) throw new Error('license_request_failed');
      return response.json();
    })
    .then((license) => {
      if (license?.valid === true && license.shop === config.shop) {
        setState('verified', 'Licença do tema validada.', license.features);
        return;
      }

      const state = license?.state === 'locked' ? 'locked' : 'restricted';
      const message = state === 'locked'
        ? 'Licença inativa. Este tema personalizado foi bloqueado.'
        : 'Licença inválida para esta loja. Recursos premium foram desativados.';
      setState(state, message);
    })
    .catch(() => {
      setState('unverified', 'Não foi possível validar a licença agora. A loja continua ativa.');
    });
})();
